import {action, observable} from 'mobx';
import GoToPage from '@common/GoToPage';
import * as NavConfig from '@common/NavConfig';
import login_user_store from '@src/Store/LoginUser/LoginUserStore';

const localStorage_breadcrumb_key = 'breadcrumb';

class Item {
  constructor(data) {
    this.init(data);
  }

  @action
  init(data) {
    for (let attr in data) {
      this[attr] = data[attr];
    }
  }

  //跳转路径
  @observable
  path = '';

  //名称
  @observable
  name = '';

  //id
  @observable
  id = '';

  //名称
  @observable
  userName = '';

  //跳转类型 0:用户 1:代理
  @observable
  type = 0;
}

class MyBreadcrumb {

  itemList = [];

  constructor() {
    this.loadLocalData()
  }


  loadLocalData() {
    let data = localStorage.getItem(localStorage_breadcrumb_key);

    if (data !== null) {
      this.itemList = JSON.parse(data);
    }
  }

  saveLocalData() {
    localStorage.setItem(localStorage_breadcrumb_key, JSON.stringify(this.itemList));
  }

  clearLocalData() {
    this.itemList = [];
    this.saveLocalData();
  }


  setBreadcrumbList(itemList) {
    this.itemList = [];
    this.itemList = this.itemList.concat(itemList)
  }

  addItem(item) {
    this.itemList.push(item)
  }

  resetByName(name, title) {
    this.itemList = [];

    let item = new Item();
    item.name = title != undefined ? title : name;
    item.id = name;

    let node = NavConfig.getNavNodeByName(name);

    if (node != undefined)
    {
      item.path = node.path;
    }


    this.itemList.push(item);

    this.saveLocalData();
  }

  resetUser(type, userId, userName) {
    this.itemList = [];

    let item = new Item();
    item.name = `我的会员`;
    item.userName = login_user_store.pet_name;
    item.id = login_user_store.id;

    let path = this.getUserItemPath(
      type,
      login_user_store.id,
      login_user_store.pet_name);
    item.path = path;

    item.type = 0;

    this.itemList.push(item);

    if (userId != login_user_store.id) {
      let item2 = new Item();
      item2.name = `${userName}的下线会员`;
      item2.userName = userName;
      item.id = userId;

      let path = this.getUserItemPath(type, userId, userName);
      item2.path = path;

      item2.type = 0;

      this.itemList.push(item2);
    }

    this.saveLocalData();
  }

  resetProxy(userId, userName) {
    this.itemList = [];

    let item = new Item();
    item.name = `我的代理`;
    item.userName = userName;
    item.id = login_user_store.id;

    let path = this.getProxyItemPath(login_user_store.id, login_user_store.pet_name);
    item.path = path;

    item.type = 1;

    this.itemList.push(item)

    if (userId != login_user_store.id) {
      let item2 = new Item();
      item2.name = `${userName}的下线代理`;
      item2.userName = userName;
      item.id = userId;

      let path = this.getProxyItemPath(userId, userName);
      item2.path = path;

      item2.type = 1;

      this.itemList.push(item2);
    }

    this.saveLocalData();
  }

  //添加用户列表跳转
  addUserItem(type, userId, userName) {
    let lastItem = this.isExist(0,userId);

    if (lastItem != undefined)
    {
      this.popItem(lastItem);
      this.saveLocalData();
      return
    }

    let item = new Item();
    item.name = `${userName}的下线会员`;
    item.userName = userName;
    item.id = userId;

    item.path = this.getUserItemPath(type, userId, userName);

    item.type = 0;
    this.itemList.push(item);

    this.saveLocalData();
  }

  getUserItemPath(type, userId, userName) {
    return GoToPage.getUserItemPath(type, userId, userName);
  }

  //添加代理列表跳转
  addProxyItem(proxyId, userName) {

    let lastItem = this.isExist(1,proxyId);

    if (lastItem != undefined)
    {
      this.popItem(lastItem);
      this.saveLocalData();
      return
    }

    let item = new Item();
    item.name = `${userName}的下线代理`;
    item.userName = userName;
    item.id = proxyId;

    item.path = this.getProxyItemPath(proxyId, userName);

    item.type = 1;
    this.itemList.push(item);

    this.saveLocalData();
  }

  getProxyItemPath(userId, userName) {
    return GoToPage.getProxyItemPath(userId, userName);
  }

  isExist(type, id) {
    for (let i = 0; i < this.itemList.length; i++) {
      let item = this.itemList[i];
      if (type == item.type && item.id == id) {
        return item;
      }
    }

    return undefined;
  }

  popItem(item) {
    let index = this.itemList.indexOf(item);

    //移除之后的列表
    this.itemList.splice(index + 1);

    this.saveLocalData();
  }
}

let global_store = new MyBreadcrumb();

export default global_store;



// WEBPACK FOOTER //
// ./src/Store/Common/MyBreadcrumb.js